
var validacaoForm = {
  methods:{
      validacaoForm (item, label){
        var errors = []
        item.$params.errors = []
        if (!item.$dirty) { return null }
        if (item.hasOwnProperty("required") && !item.required) {
          item.$params.errors.push('Campo '+label+' é Obrigatório')
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("minLength") && !item.minLength) {
          item.$params.errors.push('Informe no mínimo '+item.$params.minLength.min+ ' caracteres')
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("maxLength") && !item.maxLength) {
          item.$params.errors.push('Informe no máximo '+item.$params.maxLength.max+ ' caracteres')
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("email") && !item.email) {
          item.$params.errors.push('Insira um e-mail válido') 
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("validaCpfCnpj") && !item.validaCpfCnpj) {
          let doc
          item.$model.length <= 14 ? doc = 'CPF' : doc = 'CNPJ'
          item.$params.errors.push('Insira '+doc+' válido') 
          errors = item.$params.errors
          return errors.toString() 
        }
        return errors.toString()
      }
  }
};

export default validacaoForm;


// WEBPACK FOOTER //
// ./src/mixins/validacaoForm.js